export const mixins = {
  data() {
    return {
      chartsTheme: require('@/const/macarons.json'), // 圖表主題
    }
  },
  methods: {
    // dialog 寬度設定
    setDialogWidth() { // dialog responsive
      let val = document.body.clientWidth
      let dialogWidth
      const def = 1300 // 默認寬度
      if (val < def) {
        dialogWidth = '90%'
      } else {
        dialogWidth = def + 'px'
      }
      return dialogWidth
    },
    // 日期格式 yyyy-MM-DD 
    parseDateTime(datetime) {
      if (datetime) {
        let dt = this.$moment(datetime).tz('Asia/Taipei').format() // 轉為台灣時區
        return dt.replace('T',' ').substring(0,10)
      } 
    },
    // 日期格式 yyyy-MM-DD hh:mm:ss
    parseDateTimeToHHMMSS(datetime) {
      if (datetime) {
        let dt = this.$moment(datetime).tz('Asia/Taipei').format() // 轉為台灣時區
        return dt.replace('T',' ').substring(0,19)
      } 
    },
    /* N days ago
      date 可為 Date()
      return yyyy-MM-dd
    */
    getNDaysAgo(N, date) {
      const daysAgo = new Date(date.getTime())
      daysAgo.setDate(date.getDate() - N)
      return daysAgo.toISOString().substring(0,10)
    },
    /* N days after
      date 可為 Date()
      return yyyy-MM-dd
    */
    getNDaysAfter(N, date) {
      const daysAfter = new Date(date)
      daysAfter.setDate(daysAfter.getDate() + N)
      return daysAfter.toISOString().substring(0,10)
    },
    // table排序
    tableSortChange(column) { // 自定義排序方式
      if (column.prop.indexOf('profile.') != -1) {
        column.prop = column.prop.replace('profile.','')
      }
      if (column.order === 'descending') {
        this.listQuery.sort = column.prop + ',' + 'DESC'
      } else {
        this.listQuery.sort = column.prop + ',' + 'ASC'
      }
      this.getList()
    },
    // getDictionaryByCategory(category) { // 依類型查詢代碼表
    //   return this.axios.get("/api/system/dictionary/" + category).then(res => {
    //     return res.data
    //   })
    // },
    // // 動態取得採購編號列表
    // getPurchaseNumOptions(input) {
    //   this.axios.get('/api/system/contract', {params: {purchaseNum: input, enabled: true}}).then(res => {
    //     this.purchaseNumOptions = res.data.content
    //   })
    // },
    // // 動態取得契約編號列表
    // getContractNumOptions(input) {
    //   this.axios.get('/api/system/contract', {params: {numberLike: input, enabled: true}}).then(res => {
    //     this.contractNumOptions = res.data.content
    //   })
    // },
    // // 動態取得廠商列表
    // getManufacturerOptions(input) {
    //   this.axios.get('/api/system/manufacturer', {params: {name: input, enabled: true}}).then(res => {
    //     this.manufacturerOptions = res.data.content
    //   })
    // },
    // // 動態取得傳輸模組編號列表
    // getFanOptions(input) {
    //   this.axios.get('/api/material/fan', {params: {idLike: input, enabled: true}}).then(res => {
    //     this.fanOptions = res.data.content
    //   })
    // },
    // // 動態取得監測模組編號列表
    // getMonitorOptions(input) {
    //   this.axios.get('/api/material/monitor', {params: {idLike: input, enabled: true}}).then(res => {
    //     this.monitorOptions = res.data.content
    //   })
    // },
    // // 動態取得 waterId 列表
    // getWaterIdOptions(input) {
    //   this.axios.get('/api/system/profile', {params: {waterIdLike: input, enabled: true}}).then(res => {
    //     this.waterIdOptions = res.data.content
    //   })
    // },
    // // 動態取得 waterNum 列表
    // getWaterNumOptions(input) {
    //   this.axios.get('/api/system/profile', {params: {waterNumLike: input, enabled: true}}).then(res => {
    //     this.waterNumOptions = res.data.content
    //     // console.log('waterNumOptions', this.waterNumOptions)
    //   })
    // },
    // // 動態取得 unitRule 列表 (取得水號隸屬管理單位底下的規則)
    // getUnitRuleOptions(input) {
    //   this.axios.get('/api/alarm/rule', {params: {nameLike: input, unitId: this.selectedUnitId, waterNumIsNull: true, enabled: true}}).then(res => {
    //     // console.log('getUnitRuleOptions', res.data.content)
    //     this.unitRuleOptions = res.data.content
    //   })
    // },
    // // 匯出檔案
    // exportFile(queryUrl, queryParams) {
    //   this.axios.get(queryUrl,  {params: queryParams, responseType: 'blob'}).then(response => {
    //     const url = window.URL.createObjectURL(new Blob([response.data]))
    //     const link = document.createElement('a') // 利用<a>標籤下載
    //     link.style.display = 'none'
    //     link.href = url
    //     const fileName = decodeURI(response.headers['content-disposition'].split(';')[1].split('=')[1])
    //     link.setAttribute('download', fileName)
    //     document.body.appendChild(link)
    //     link.click()
    //     document.body.removeChild(link)
    //   })
    // },
    // // 依 異常群組 取得 查察結果列表
    // async getAlarmDiagnosticList(categoryId) {
    //   if (categoryId) {
    //     return this.axios.get('/api/alarm/category/'+ categoryId +'/diagnostic').then(response => {
    //       return response.data
    //     })
    //   }
    // },
    // 依 異常群組 取得 建議方案列表
    async getAlarmSuggestionList(categoryId) {
      if (categoryId) {
        return this.axios.get('/api/report/profile/alarm/category/'+ categoryId +'/suggestion').then(response => {
          return response.data
        })
      }
    },
    // // 動態取得 Account 列表
    // async getAccountOptions(input) {
    //   this.axios.get('/api/system/account', {params: {accountLike: input, enabled: true}}).then(res => {
    //     // console.log('account options', res.data.content)
    //     this.accountOptions = res.data.content
    //   })
    // },
    // // 動態取得 meterReplacementGroup 水栓群組列表
    // async getMeterReplacementGroupOptions(input) {
    //   this.axios.get('/api/install/group', {params: {nameLike: input }}).then(res => {
    //     this.meterReplacementGroupOptions = res.data.content
    //   })
    // }
   } 
}

